import { idbGet, idbPut, STORES } from './idb';

// نفس قواعد الخادم (services/inspection-code.service.js):
// المزاد (خانتان) + المستخدم (3 خانات) + تسلسل المستخدم داخل المزاد (6 خانات) ← 05011000001.
const AUCTION_DIGITS = 2;
const USER_DIGITS = 3;
const SEQ_DIGITS = 6;

function pad(value, width) {
  const text = String(Math.max(0, Math.trunc(Number(value) || 0)));
  return text.length >= width ? text : text.padStart(width, '0');
}

export function codePrefix(auctionId, userId) {
  return `${pad(auctionId, AUCTION_DIGITS)}${pad(userId, USER_DIGITS)}`;
}

export function formatInspectionCode(auctionId, userId, seq) {
  return `${codePrefix(auctionId, userId)}${pad(seq, SEQ_DIGITS)}`;
}

function counterKey(auctionId, userId) {
  return `code-counter:${auctionId}:${userId}`;
}

// آخر تسلسل يعرفه الخادم يُحفظ عند كل اتصال. العدّاد لا ينزل أبدًا:
// الجهاز قد يكون استهلك أرقامًا لم تُرفع بعد.
export async function updateCounterFromServer({ auction_id: auctionId, user_id: userId, last_seq: lastSeq }) {
  if (!auctionId || !userId) return;
  const key = counterKey(auctionId, userId);
  const current = Number((await idbGet(STORES.kv, key)) || 0);
  const next = Math.max(current, Number(lastSeq || 0));
  if (next !== current) await idbPut(STORES.kv, next, key);
}

// يحجز الرقم التالي على الجهاز. التسلسل يُحفظ قبل استخدام الرقم،
// فلا يُعطى الرقم نفسه مرتين حتى لو أُغلق التطبيق في منتصف الإنشاء.
export async function reserveNextCode(auctionId, userId, usedCodes = []) {
  const key = counterKey(auctionId, userId);
  const prefix = codePrefix(auctionId, userId);
  const localMax = usedCodes
    .filter((code) => String(code || '').startsWith(prefix))
    .map((code) => Number(String(code).slice(prefix.length)) || 0)
    .reduce((max, value) => Math.max(max, value), 0);

  const current = Number((await idbGet(STORES.kv, key)) || 0);
  const seq = Math.max(current, localMax) + 1;
  await idbPut(STORES.kv, seq, key);
  return formatInspectionCode(auctionId, userId, seq);
}

export async function counterKnown(auctionId, userId) {
  const value = await idbGet(STORES.kv, counterKey(auctionId, userId));
  return value !== undefined;
}
